import { useTranslation } from "react-i18next";
import { Paper, Typography, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useColorScheme } from "@mui/material/styles";
// cmp
import Svg from "../cmp/svg";
// services
import Constants from "../services/constants";
// types
import type { Appearance } from "../types/misc";

const GeneralSettingsPage = () => {
	const { t } = useTranslation();

	const { mode, setMode } = useColorScheme();

	return (
		<Paper component="section" sx={{ p: 2 }}>
			<Typography variant="h5" gutterBottom={true}>
				{t("generalSettings.appDesign")}
			</Typography>
			<ToggleButtonGroup
				sx={{ width: 1 }}
				exclusive={true}
				orientation="vertical"
				value={mode}
				onChange={(event, newMode: Appearance | null) => (setMode(newMode))}
			>
				<ToggleButton sx={{ justifyContent: "flex-start" }} value={Constants.Appearance.Light}>
					<Svg src="theme/sunny.svg" style={{marginRight: "12px"}} />
					{t("generalSettings.light")}
				</ToggleButton>
				<ToggleButton sx={{ justifyContent: "flex-start" }} value={Constants.Appearance.Dark}>
					<Svg src="theme/night.svg" style={{marginRight: "12px"}} />
					{t("generalSettings.dark")}
				</ToggleButton>
				<ToggleButton sx={{ justifyContent: "flex-start" }} value={Constants.Appearance.System}>
					<Svg src="theme/systemDefault.svg" style={{marginRight: "12px"}} />
					{t("generalSettings.system")}
				</ToggleButton>
			</ToggleButtonGroup>
		</Paper>
	);
};

export default GeneralSettingsPage;
